// extracted by mini-css-extract-plugin
module.exports = {"root":"SurveyIcon_qmee_root__k8Yq7","streakOverlay":"SurveyIcon_qmee_streakOverlay__3s_3l","icon":"SurveyIcon_qmee_icon__NzwS2"};